import { isFulfilled, isRejectedWithValue, Middleware } from "@reduxjs/toolkit";
import { toast } from "../core/toast";

/**
 * Middleware to show global toast messages for RTK Query actions.
 */
export const rtkQueryToastMiddleware: Middleware = () => (next) => (action: any) => {
  // 1. Handle Rejected Actions (Errors)
  if (isRejectedWithValue(action)) {
    const errorData = action.payload as any;
    
    // Attempt to extract the most meaningful error message
    const errorMessage = 
      errorData?.data?.message || 
      errorData?.message || 
      (typeof errorData?.data === 'string' ? errorData.data : null) ||
      "An unexpected error occurred";
    
    toast.error(errorMessage);
  } else if (action.type.endsWith("/rejected")) {
    // Skip internal RTK Query rejections that shouldn't be shown to users
    // 1. Condition failures (e.g., prevents duplicate requests)
    if (action.meta?.condition) {
      return next(action);
    }

    // 2. Explicitly aborted requests (AbortError)
    if (action.error?.name === 'AbortError') {
      return next(action);
    }

    // Handle other cases where there is no payload (e.g., network errors)
    const errorMessage = action.error?.message || "Network error or request aborted";
    toast.error(errorMessage);
  }

  // 2. Handle Fulfilled Actions (Success)
  if (isFulfilled(action)) {
    // We typically only want success toasts for mutations (POST, PATCH, PUT, DELETE)
    // RTK Query adds 'executeMutation' to the action type for mutations
    if (action.type.includes("executeMutation")) {
      const payload = action.payload as any;
      
      // Attempt to extract the most meaningful success message
      const successMessage = 
        payload?.message || 
        payload?.result?.message ||
        "Operation successful";
      
      toast.success(successMessage);
    }
  }

  return next(action);
};
